import {
  POST_SIGNOZ_ENABLE_DISABLE_ALERTS,
  POST_SIGNOZ_ENABLE_DISABLE_ALERTS_FAIL,
  POST_SIGNOZ_ENABLE_DISABLE_ALERTS_SUCCESS,
  POST_SIGNOZ_CREATE_RESOURCE_ALERTS,
  POST_SIGNOZ_CREATE_RESOURCE_ALERTS_FAIL,
  POST_SIGNOZ_CREATE_RESOURCE_ALERTS_SUCCESS,
  POST_SIGNOZ_CREATE_DYNAMIC_ALERT,
  POST_SIGNOZ_CREATE_DYNAMIC_ALERT_FAIL,
  POST_SIGNOZ_CREATE_DYNAMIC_ALERT_SUCCESS,
  GET_SIGNOZ_ALERTS,
  GET_SIGNOZ_ALERTS_FAIL,
  GET_SIGNOZ_ALERTS_SUCCESS, 
  GET_SIGNOZ_DYNAMIC_ALERTS,
  GET_SIGNOZ_DYNAMIC_ALERTS_FAIL,
  GET_SIGNOZ_DYNAMIC_ALERTS_SUCCESS,
  GET_SIGNOZ_MISSING_DYNAMIC_ALERTS,
  GET_SIGNOZ_MISSING_DYNAMIC_ALERTS_FAIL,
  GET_SIGNOZ_MISSING_DYNAMIC_ALERTS_SUCCESS,
  GET_SIGNOZ_DEFAULT_THRESHOLD,
  GET_SIGNOZ_DEFAULT_THRESHOLD_FAIL,
  GET_SIGNOZ_DEFAULT_THRESHOLD_SUCCESS,
  GET_SIGNOZ_RESOURCE_BY_ID,
  GET_SIGNOZ_RESOURCE_BY_ID_FAIL,
  GET_SIGNOZ_RESOURCE_BY_ID_SUCCESS,
  GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
  GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
  GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
  POST_SIGNOZ_ALERT,
  POST_SIGNOZ_ALERT_FAIL,
  POST_SIGNOZ_ALERT_SUCCESS,
  GET_SIGNOZ_RESCAN,
  GET_SIGNOZ_RESCAN_FAIL,
  GET_SIGNOZ_RESCAN_SUCCESS,
  GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID,
  GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
  GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
  GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE,
  GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
  GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
  POST_SIGNOZ_SERVICE_MAPPING,
  POST_SIGNOZ_SERVICE_MAPPING_FAIL,
  POST_SIGNOZ_SERVICE_MAPPING_SUCCESS,
  POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  GET_SIGNOZ_RESOURCES,
  GET_SIGNOZ_RESOURCES_FAIL,
  GET_SIGNOZ_RESOURCES_SUCCESS,
  GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES,
  GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES_FAIL,
  GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES_SUCCESS,
  GET_RESCAN_STATUS_SIGNOZ,
  GET_RESCAN_STATUS_SIGNOZ_FAIL,
  GET_RESCAN_STATUS_SIGNOZ_SUCCESS,
  POST_UPDATE_SIGNOZ_THRESHOLD,
  POST_UPDATE_SIGNOZ_THRESHOLD_FAIL,
  POST_UPDATE_SIGNOZ_THRESHOLD_SUCCESS,
  POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD,
  POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD_FAIL,
  POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD_SUCCESS,
  GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_SIGNOZ_THRESHOLD,
  GET_SIGNOZ_THRESHOLD_FAIL,
  GET_SIGNOZ_THRESHOLD_SUCCESS,
    GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS,
    GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS_FAIL,
    GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
    GET_SIGNOZ_ALL_EXTERNAL_SERVICES,
    GET_SIGNOZ_ALL_EXTERNAL_SERVICES_FAIL,
    GET_SIGNOZ_ALL_EXTERNAL_SERVICES_SUCCESS,
    GET_SIGNOZ_NON_KEY_TRANSACTIONS,
    GET_SIGNOZ_NON_KEY_TRANSACTIONS_FAIL,
    GET_SIGNOZ_NON_KEY_TRANSACTIONS_SUCCESS,
    POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
    POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL,
    POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS,

 } from "./actionTypes";


export const postEnableDisableSignozThreshold = (data) => ({
  type: POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD,
  payload: data,
})

export const postEnableDisableSignozThresholdFail = error => ({
  type: POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD_FAIL,
  payload: error,
})

export const postEnableDisableSignozThresholdSuccess = (response) => ({
  type: POST_ENABLE_DISABLE_SIGNOZ_THRESHOLD_SUCCESS,
  payload: response,
})

export const postUpdateSignozThreshold = (data) => ({
  type: POST_UPDATE_SIGNOZ_THRESHOLD,
  payload: data
})

export const postUpdateSignozThresholdFail = error => ({
  type: POST_UPDATE_SIGNOZ_THRESHOLD_FAIL,
  payload: error
})

export const postUpdateSignozThresholdSuccess = (response) => ({
  type: POST_UPDATE_SIGNOZ_THRESHOLD_SUCCESS,
  payload: response
})

export const getRescanStatusSignoz = (data) => ({
  type: GET_RESCAN_STATUS_SIGNOZ,
  payload: data
})

export const getRescanStatusSignozFail = error => ({
  type: GET_RESCAN_STATUS_SIGNOZ_FAIL,
  payload: error
})

export const getRescanStatusSignozSuccess = (signoz_rescan_status) => ({
  type: GET_RESCAN_STATUS_SIGNOZ_SUCCESS,
  payload: signoz_rescan_status
})

export const getSignozRescan = () => ({
  type: GET_SIGNOZ_RESCAN,
  payload: []
})

export const getSignozRescanFail = error => ({
  type: GET_SIGNOZ_RESCAN_FAIL,
  payload: error
})

export const getSignozRescanSuccess = (data) => ({
  type: GET_SIGNOZ_RESCAN_SUCCESS,
  payload: data
})

export const getSignozResources = () => ({
  type: GET_SIGNOZ_RESOURCES,
})

export const getSignozResourcesFail = error => ({
  type: GET_SIGNOZ_RESOURCES_FAIL,
  payload: error
})

export const getSignozResourcesSuccess = signoz_resources => ({
  type: GET_SIGNOZ_RESOURCES_SUCCESS,
  payload: signoz_resources
})

export const getSignozMissingAlertByResourceId = (monitored_resource_id) => ({
  type: GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID,
  payload: monitored_resource_id
})

export const getSignozMissingAlertByResourceIdFail = error => ({
  type: GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
  payload: error
})

export const getSignozMissingAlertsByResourceIdSuccess = (response) => ({
  type: GET_SIGNOZ_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
  payload: response
})

export const getSignozAllResourceAlertsPage = (data) => ({
  type: GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE,
  payload: data
})

export const getSignozAllResourceAlertsPageFail = error => ({
  type: GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  payload: error
})

export const getSignozAllResourceAlertsPageSuccess = (signoz_all_resource_alerts) => ({
  type: GET_SIGNOZ_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  payload: signoz_all_resource_alerts
})

export const getSignozAllResourceAlertsCountPage = (data) => ({
  type: GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  payload: data
})

export const getSignozAllResourceAlertsCountPageFail = error => ({
  type: GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
  payload: error
})

export const getSignozAllResourceAlertsCountPageSuccess = (signoz_all_resource_alerts_count) => ({
  type: GET_SIGNOZ_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
  payload: signoz_all_resource_alerts_count
})

export const postSignozAlert = (data) => ({
  type: POST_SIGNOZ_ALERT,
  payload: data
})

export const postSignozAlertFail = error => ({
  type: POST_SIGNOZ_ALERT_FAIL,
  payload: error
})

export const postSignozAlertsSuccess = (response) => ({
    type: POST_SIGNOZ_ALERT_SUCCESS,
    payload: response
})

export const postSignozServiceMapping = (data) => ({
  type: POST_SIGNOZ_SERVICE_MAPPING,
  payload: data
})

export const postSignozServiceMappingFail = error => ({
  type: POST_SIGNOZ_SERVICE_MAPPING_FAIL,
  payload: error
})

export const postSignozServiceMappingSuccess = (response) => ({
  type: POST_SIGNOZ_SERVICE_MAPPING_SUCCESS,
  payload: response
})

export const postSignozResourceOpsGenieTeamMapping = (data) => ({
  type: POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING,
  payload: data
})

export const postSignozResourceOpsGenieTeamMappingFail = error => ({
  type: POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  payload: error
})

export const postSignozResourceOpsGenieTeamMappingSuccess = (response) => ({
  type: POST_SIGNOZ_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  payload: response
})

export const postSignozResourcePagerdutyMapping = (data) => ({
  type: POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  payload: data
})

export const postSignozResourcePagerdutyMappingFail = error => ({
  type: POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  payload: error
})

export const postSignozResourcePagerdutyMappingSuccess = (response) => ({
  type: POST_SIGNOZ_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  payload: response
})

export const getAllOrgSignozResourceTypes = () => ({
  type: GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES
})

export const getAllOrgSignozResourceTypesFail = error => ({
  type: GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES_FAIL,
  payload: error
})

export const getAllOrgSignozResourceTypesSuccess = orgSignozResourceTypes => ({
  type: GET_ALL_ORG_SIGNOZ_RESOURCE_TYPES_SUCCESS,
  payload: orgSignozResourceTypes
})


 export const postSignozEnableDisableAlerts = (data) => ({
    type: POST_SIGNOZ_ENABLE_DISABLE_ALERTS,
    payload: { data }
 })

 export const postSignozEnableDisableAlertsFail = error =>({
    type: POST_SIGNOZ_ENABLE_DISABLE_ALERTS_FAIL,
    payload: error
 })

 export const postSignozEnableDisableAlertsSuccess = (response) => ({
    type: POST_SIGNOZ_ENABLE_DISABLE_ALERTS_SUCCESS,
    payload: response
 })

 export const postSignozCreateResourceAlerts = (data) => ({
  type: POST_SIGNOZ_CREATE_RESOURCE_ALERTS,
  payload: { data }
 })

 export const postSignozCreateResourceAlertsFail = error => ({
  type: POST_SIGNOZ_CREATE_RESOURCE_ALERTS_FAIL,
  payload: error
 })

 export const postSignozCreateResourceAlertsSuccess = (response) => ({
  type: POST_SIGNOZ_CREATE_RESOURCE_ALERTS_SUCCESS,
  payload: response
 })

 export const postSignozCreateDynamicAlert = (data) =>({
  type: POST_SIGNOZ_CREATE_DYNAMIC_ALERT,
  payload: { data }
 })

export const postSignozCreateDynamicAlertSuccess = (response) => ({
  type: POST_SIGNOZ_CREATE_DYNAMIC_ALERT_SUCCESS,
  payload: response
})

export const postSignozCreateDynamicAlertFail = error => ({
  type: POST_SIGNOZ_CREATE_DYNAMIC_ALERT_FAIL,
  payload: error
})

export const getSignozAlerts = (monitored_resource_id) => (
    {
      type: GET_SIGNOZ_ALERTS,
      payload: monitored_resource_id
    }
)

export const getSignozAlertsSuccess = signoz_alerts => ({
  type: GET_SIGNOZ_ALERTS_SUCCESS,
  payload: signoz_alerts
})

export const getSignozAlertsFail = error => ({
  type: GET_SIGNOZ_ALERTS_FAIL,
  payload: error
})

export const getSignozDynamicAlerts = (monitored_resource_id) => ({
  type: GET_SIGNOZ_DYNAMIC_ALERTS,
  payload: monitored_resource_id
})

export const getSignozDynamicAlertsSuccess = signoz_dynamic_alerts => ({
  type: GET_SIGNOZ_DYNAMIC_ALERTS_SUCCESS,
  payload: signoz_dynamic_alerts
})

export const getSignozDynamicAlertsFail = error => ({
  type: GET_SIGNOZ_DYNAMIC_ALERTS_FAIL,
  payload: error
})

export const getSignozMissingDynamicAlerts = (monitored_resource_id) => ({
  type: GET_SIGNOZ_MISSING_DYNAMIC_ALERTS,
  payload: monitored_resource_id
})

export const getSignozMissingDynamicAlertsFail = error => ({
  type: GET_SIGNOZ_MISSING_DYNAMIC_ALERTS_FAIL,
  payload: error
})

export const getSignozMissingDynamicAlertsSuccess = signoz_missing_dynamic_alerts => ({
  type: GET_SIGNOZ_MISSING_DYNAMIC_ALERTS_SUCCESS,
  payload: signoz_missing_dynamic_alerts
})

export const getSignozDefaultThreshold = threshold_type => ({
  type: GET_SIGNOZ_DEFAULT_THRESHOLD,
  payload: threshold_type
})

export const getSignozDefaultThresholdFail = error => ({
  type: GET_SIGNOZ_DEFAULT_THRESHOLD_FAIL,
  payload: error
})

export const getSignozDefaultThresholdSuccess = defaultThreshold => ({
  type: GET_SIGNOZ_DEFAULT_THRESHOLD_SUCCESS,
  payload: defaultThreshold
})

export const getSignozThreshold = metric_id => ({
  type: GET_SIGNOZ_THRESHOLD,
  payload: metric_id
})

export const getSignozThresholdFail = error => ({
  type: GET_SIGNOZ_THRESHOLD_FAIL,
  payload: error
})

export const getSignozThresholdSuccess = appDynamicsThreshold => ({
  type: GET_SIGNOZ_THRESHOLD_SUCCESS,
  payload: appDynamicsThreshold
})

export const getSignozResourceById = monitored_resource_id => ({
  type: GET_SIGNOZ_RESOURCE_BY_ID,
  payload: monitored_resource_id
})

export const getSignozResourceByIdSuccess = signoz_resource => ({
  type: GET_SIGNOZ_RESOURCE_BY_ID_SUCCESS,
  payload: signoz_resource
})

export const getSignozResourceByIdFail = error => ({
  type: GET_SIGNOZ_RESOURCE_BY_ID_FAIL,
  payload: error
})

export const getSignozResourcesDefaultThresholdById = monitored_resource_id => (
    {
    type: GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
    payload: monitored_resource_id
  }
)

export const getSignozResourcesDefaultThresholdByIdSuccess = signoz_resource_default_threshold => ({
  type: GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
  payload: signoz_resource_default_threshold
})

export const getSignozResourcesDefaultThresholdByIdFail = error => ({
  type: GET_SIGNOZ_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
  payload: error
})

export const getMissingSignozAlertsByResourceID = data => ({
  type: GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID,
  payload: data
})

export const getMissingSignozAlertsByResourceIDSuccess = signoz_resource_missing_alerts => ({
  type: GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  payload: signoz_resource_missing_alerts,
})

export const getMissingSignozAlertsByResourceIDFail = error => ({
  type: GET_SIGNOZ_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const getSignozAllBusinessTransactions = (data) => ({
  type: GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS,
  payload: data
})

export const getSignozAllBusinessTransactionsFail = error => ({
  type: GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS_FAIL,
  payload: error
})

export const getSignozAllBusinessTransactionsSuccess = (signoz_all_resource_alerts) => ({
  type: GET_SIGNOZ_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
  payload: signoz_all_resource_alerts
})


export const getSignozAllExternalServicesPage = (data) => ({
  type: GET_SIGNOZ_ALL_EXTERNAL_SERVICES,
  payload: data
})

export const getSignozAllExternalServicesPageFail = error => ({
  type: GET_SIGNOZ_ALL_EXTERNAL_SERVICES_FAIL,
  payload: error
})

export const getSignozAllExternalServicesPageSuccess = (signoz_all_resource_alerts) => ({
  type: GET_SIGNOZ_ALL_EXTERNAL_SERVICES_SUCCESS,
  payload: signoz_all_resource_alerts
})

export const getSignozNonKeyTransactions = (page_filters) => ({
    type: GET_SIGNOZ_NON_KEY_TRANSACTIONS,
    payload: page_filters
})

export const getSignozNonKeyTransactionsFail = error => ({
    type: GET_SIGNOZ_NON_KEY_TRANSACTIONS_FAIL,
    payload: error
})

export const getSignozNonKeyTransactionsSuccess = (response) => ({
    type: GET_SIGNOZ_NON_KEY_TRANSACTIONS_SUCCESS,
    payload: response
})

export const postMarkNonKeySignozTransactionAsBusinessTransaction = (data) => ({
    type: POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
    payload: data
})

export const postMarkNonKeySignozTransactionAsBusinessTransactionFail = error => ({
    type: POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL,
    payload: error
})

export const postMarkNonKeySignozTransactionAsBusinessTransactionSuccess = (response) => ({
    type: POST_MARK_SIGNOZ_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS,
    payload: response
})

